import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect } from "react";
import ActionBar from "./components/ActionBar";
import Breadcrumb from "./components/Breadcrumb";
import { SideNav } from "./sidenav/SideNav";
import TopNav from "./topnav/TopNav";
const Grid_container = styled(Grid)(({ theme }) => ({
    height: "6rem", //"var(--side-menu-width)",
    width: "100vw",
    paddingLeft: "6rem", //var(--side-menu-width)",
    backgroundColor: "#FFFFFF", // "var(--clr-white)"
    zIndex: 100,
    position: "fixed",
    top: 0,
}));
const Header = (props) => {
    useEffect(() => {
        // TODO: ask portal about supported languages
        if (props.appModel.language &&
            props.appModel.language in _supportedPortalLanguages()) {
            props.appModel.appState.setHomeUrl("/" + props.appModel.language);
        }
        else {
            props.appModel.appState.setHomeUrl("/");
        }
    }, []);
    const _supportedPortalLanguages = () => {
        // TODO: ask portal about supported languages
        return { de: true, en: true };
    };
    const renderDefaultHeader = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(SideNav, { appModel: props.appModel }),
            React.createElement(TopNav, { appModel: props.appModel }),
            React.createElement(Breadcrumb, { appModel: props.appModel }),
            React.createElement(ActionBar, { hideDefaultActions: props.hideDefaultActions, appModel: props.appModel })));
    };
    return (React.createElement("header", { id: "zebDshAppFrameHeader", className: "header" },
        React.createElement(Grid_container, { container: true, wrap: "nowrap", justifyContent: "space-between" }, props.children ? props.children : renderDefaultHeader())));
};
export default Header;
